import React from 'react';

const Footer = () => {
    return (
		<footer className="footer">
			<div className="container">
				<div className="row">
					<div className="col-12">
						<div className="footer__copyright">
							<small>Geliştirici Selin Öser</small>
							<ul>
								<li><a href="mailto:selinoser@gmail.com">İletişim: selinoser@gmail.com</a></li>
							</ul>
						</div>
					</div>
				</div>
			</div>
		</footer>
    )
}

export default Footer;
